function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";

var SvgBoxIn = function SvgBoxIn(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Box In' : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement(SvgIcon, _extends({
    title: title
  }, props, {
    viewBox: "0 0 48 48"
  }), React.createElement("polygon", {
    points: "23.0517 0.0003 23.0517 19.5863 15.7577 12.2933 14.3447 13.7073 24.0517 23.4133 33.7577 13.7073 32.3447 12.2933 25.0517 19.5863 25.0517 0.0003"
  }), React.createElement("path", {
    d: "M4.8984,46 L43.2044,46 L45.8704,30 L31.8054,30 L31.3864,31.467 C30.4554,34.725 27.4394,37 24.0514,37 C20.6634,37 17.6474,34.725 16.7164,31.467 L16.2964,30 L2.2314,30 L4.8984,46 Z M44.8984,48 L3.2044,48 L0.0004,28.774 L8.2194,16.445 L9.8834,17.555 L2.9194,28 L17.8054,28 L18.6394,30.917 C19.3264,33.321 21.5514,35 24.0514,35 C26.5514,35 28.7764,33.321 29.4634,30.917 L30.2964,28 L45.1824,28 L38.2194,17.555 L39.8834,16.445 L48.1024,28.774 L44.8984,48 Z"
  }));
};

SvgBoxIn = pure(SvgBoxIn);
SvgBoxIn.displayName = 'SvgBoxIn';
export default SvgBoxIn;